import { render, staticRenderFns } from "./LicenseConfirmationModal.vue?vue&type=template&id=ada8c1e2&scoped=true"
import script from "./LicenseConfirmationModal.vue?vue&type=script&lang=js"
export * from "./LicenseConfirmationModal.vue?vue&type=script&lang=js"
import style0 from "./LicenseConfirmationModal.vue?vue&type=style&index=0&id=ada8c1e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada8c1e2",
  null
  
)

export default component.exports